import React, { Component, Fragment } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Accordion } from 'components/accordion';
import { Button, Loading } from 'components/cosmos';
import { translate } from 'components/translate';
import { inject, observer } from 'mobx-react';
import { CommunityService } from 'modules/community';
import CommentListService from 'modules/community/commentList/CommentListService';
import { commentDataProptype } from 'modules/community/commentList/DataPropType';
import CommentChat from 'modules/community/commons/CommentChat';
import { DEFAULT_PAGE_SIZE } from 'modules/community/constants';
import CommunityHistoryService from 'modules/community/history/CommunityHistoryService';
import { UiService } from 'modules/ui';
import PropTypes from 'prop-types';

import './CommentDetailAnswers.scss';

@translate()
@inject((stores) => ({
  hash: stores.UserStore.hash
}))
@observer
export default class CommentDetailAnswers extends Component {
  static propTypes = {
    t: PropTypes.func,
    hash: PropTypes.string,
    item: PropTypes.shape(commentDataProptype),
    accordionOpened: PropTypes.object,
    onToggleAccordion: PropTypes.func
  };

  state = {
    answersList: [],
    answerBoxOpened: {},
    showMoreComments: {},
    answerListText: {},
    loading: false,
    numberOfElements: DEFAULT_PAGE_SIZE,
    loadMoreComments: false,
    showAnswers: false
  };

  constructor(props) {
    super(props);

    this.renderCommentDetail = this.renderCommentDetail.bind(this);
    this.onToggleAccordion = this.onToggleAccordion.bind(this);
    this.renderTopicComments = this.renderTopicComments.bind(this);
    this.toogleLoading = this.toogleLoading.bind(this);
    this.toogleAnswer = this.toogleAnswer.bind(this);
    this.showMore = this.showMore.bind(this);
    this.onAnswerText = this.onAnswerText.bind(this);
    this.getMoreComments = this.getMoreComments.bind(this);
    this.commentAnswerReply = this.commentAnswerReply.bind(this);
    this.getShowAnswers = this.getShowAnswers.bind(this);
  }

  async componentDidMount() {
    await this.getShowAnswers();
  }

  toogleLoading() {
    this.setState((prevState) => ({ loading: !prevState.loading }));
  }

  async getMoreComments() {
    const { numberOfElements } = this.state;

    await this.getHistoryReply(DEFAULT_PAGE_SIZE + numberOfElements);
  }

  async getShowAnswers() {
    const { item } = this.props;

    const parent = item.id;
    const userId = item.user.id;

    const params = {
      sort: 'createDate,asc',
      page: 0,
      size: 1
    };

    const response = await CommunityService.getHistoryReply(
      parent,
      userId,
      params
    );

    if (response.totalElements) {
      this.setState({ showAnswers: true });
    }
  }

  async getHistoryReply(size = DEFAULT_PAGE_SIZE) {
    const { item } = this.props;

    this.toogleLoading();

    const parent = item.id;
    const userId = item.user.id;

    const params = {
      sort: 'createDate,asc',
      page: 0,
      size
    };

    const response = await CommunityService.getHistoryReply(
      parent,
      userId,
      params
    );

    if (response) {
      this.setState({
        answersList: response.content,
        numberOfElements: response.numberOfElements,
        loadMoreComments: response.totalElements > response.numberOfElements
      });
    }

    this.toogleLoading();
  }

  async onToggleAccordion() {
    const { onToggleAccordion } = this.props;

    await onToggleAccordion();
    await this.getHistoryReply();
  }

  async commentStatusUpdate(answerData, status) {
    const response = await CommentListService.commentStatusUpdate(
      answerData,
      status
    );

    if (response) {
      UiService.setAlertSuccess(CommunityHistoryService.statusMessage[status]);

      await this.getHistoryReply();
    }
  }

  async commentAnswerReply(answerData, content) {
    const commentId = answerData && answerData.id;
    const commentUserId = answerData && answerData.user && answerData.user.id;
    const { hash: userId } = this.props;

    const response = await CommunityService.commentAnswerReply(
      userId,
      commentUserId,
      commentId,
      content
    );

    if (response) {
      await this.getHistoryReply();

      UiService.setAlertSuccess('community.send_notification_message_success');
    }
  }

  toogleAnswer(answerDataId) {
    const { answerBoxOpened } = this.state;

    answerBoxOpened[answerDataId] = !answerBoxOpened[answerDataId];

    this.setState({ answerBoxOpened });
  }

  showMore(answerDataId) {
    const { showMoreComments } = this.state;

    showMoreComments[answerDataId] = true;

    this.setState({ showMoreComments });
  }

  onAnswerText(event, answerDataId) {
    const { answerListText } = this.state;

    answerListText[answerDataId] = event.target.value;

    this.setState({ answerListText });
  }

  get openToggle() {
    return this.renderAnswerCloseButton(true);
  }

  get closeToggle() {
    return this.renderAnswerCloseButton(false);
  }

  get hasAnswers() {
    const { answersList } = this.state;

    return Boolean(answersList && answersList.length);
  }

  renderAnswerCloseButton = (open) => {
    const { t } = this.props;
    const label = open ? 'general.see_answers' : 'general.close';
    const icon = open ? 'chevron-down' : 'chevron-up';

    return (
      <Button variation="tertiary" size="sm">
        {t(label)}
        <FontAwesomeIcon icon={['fal', icon]} className="_ml-2" />
      </Button>
    );
  };

  renderCommentDetail = (answerData) => {
    const { answerBoxOpened, answerListText, showMoreComments } = this.state;

    return (
      <CommentChat
        showStatus
        showUserPhoto
        item={answerData}
        isTopic={false}
        commentStatusUpdate={this.commentStatusUpdate}
        onAnswerText={this.onAnswerText}
        answerListText={answerListText}
        toogleAnswer={this.toogleAnswer}
        commentAnswerReply={this.commentAnswerReply}
        answerBoxOpened={answerBoxOpened}
        showMoreComments={showMoreComments}
        showMore={this.showMore}
        userNameEmail={CommunityService.getUsernameEmail(answerData)}
      />
    );
  };

  renderTopicComments() {
    const { t } = this.props;
    const { answersList } = this.state;

    return (
      this.hasAnswers && (
        <Fragment>
          <div className="_d-flex _d-md-none _align-items-center _font-weight-bold _line-height-lg _mb-3">
            <FontAwesomeIcon icon={['fal', 'message']} className="_mr-2" />
            <span>{t('general.answers')}</span>
          </div>
          <div className="_ml-md-5">
            {answersList.map(this.renderCommentDetail)}
          </div>
        </Fragment>
      )
    );
  }

  render() {
    const { item, accordionOpened, t } = this.props;
    const { loading, loadMoreComments, showAnswers } = this.state;

    const isOpened = accordionOpened[item.id];

    return (
      <Fragment>
        <Accordion
          className="accordion-page accordion-show-toggle"
          opened={isOpened}
          onToggle={this.onToggleAccordion}
        >
          {isOpened && (
            <Accordion.Body maxHeightAuto>
              {this.renderTopicComments()}
              {loadMoreComments && (
                <Button
                  variation="secondary"
                  className="_d-block _text-1 _mx-auto"
                  onClick={this.getMoreComments}
                >
                  {t('community.load_more_comments')}
                </Button>
              )}
            </Accordion.Body>
          )}
          {showAnswers && (
            <Accordion.Toggle
              className="_h-full _text-center _border-top-0 _p-2"
              openToggle={this.openToggle}
              closeToggle={this.closeToggle}
            />
          )}
        </Accordion>
        {loading && <Loading center />}
      </Fragment>
    );
  }
}
